import { CreateElement, VNode, VNodeData, VueConstructor } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ClButtonBase from '../ClButtonBase';

@Component
export default class ClListItem extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  public button!: boolean;

  @Prop({
    type: String
  })
  public component!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  public disableGutters!: boolean;

  @Prop(Boolean)
  public selected!: boolean;

  public render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-list-item': true,
        'cl-list-item--selected': this.selected,
        'cl-list-item--gutters': !this.disableGutters
      },
      on: {
        click: (event: MouseEvent) => {
          this.$emit('click', event);
        },
        focus: (event: FocusEvent) => {
          this.$emit('focus', event);
        }
      }
    };

    let tag: string | VueConstructor<Vue> = this.component || 'li';

    if (this.button) {
      data.props = {
        component: this.component || 'button'
      };
      tag = ClButtonBase;
    }

    return h(tag, data, this.$slots.default);
  }
}
